import { render, staticRenderFns } from "./RoleSetting.vue?vue&type=template&id=087845a8&scoped=true&"
import script from "./RoleSetting.vue?vue&type=script&lang=js&"
export * from "./RoleSetting.vue?vue&type=script&lang=js&"
import style0 from "./RoleSetting.vue?vue&type=style&index=0&id=087845a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087845a8",
  null
  
)

export default component.exports